import { useNavigate, useParams } from "react-router-dom";
import "./AppEmployeeRecords.css";
import { useEffect, useState } from "react";
import { AppEmployeeRecordNew } from "./AppEmployeeRecordNew";
import { EmployeeRecord } from "winslow-core";
import { apiGetEmployeeRecordsForWorkspace } from "../../../services/EmployeeRecordService";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import { erGetCPValue } from "./employeeRecordUtils"
import { UserPlus } from "lucide-react";

const TABS = {
    EMPLOYEES: "employees",
    CONTRACTORS: "contractors",
    VENDORS: "vendors",
}

type AppEmployeeRecordsProps = {

}   

export const AppEmployeeRecords = ({} : AppEmployeeRecordsProps) => {

    const navigate = useNavigate();
    
    const storeUser = useSelector(selectUser)
    const { employeeId } = useParams();   // id or "new"
    const [employeeRecords, setEmployeeRecords] = useState<EmployeeRecord[] | undefined>(undefined);
    const [tab, setTab] = useState<string>(TABS.EMPLOYEES);

    useEffect(() => {
        if (!employeeRecords && storeUser?.currentWorkspaceId) {
            (async () => {
                const ers = await apiGetEmployeeRecordsForWorkspace(storeUser.currentWorkspaceId || "");

                if (!ers) {
                    console.error("Failed to get employee records for workspace");
                    toast("Failed to get employee records for workspace", toastFail);
                    return;
                }

                setEmployeeRecords(ers);
            })();
        }
    }, []);

    useEffect(() => {
        console.log("[AppEmployeeRecords] id: ", employeeId);
    }, [employeeId]);

    const handleEditEmployeeRecord = (er: EmployeeRecord) => {
        console.log("[AppEmployeeRecords] handleEditEmployeeRecord: ", er);
        navigate(`/app/employee-records/${er.id}`);
    }

    const inactiveEmployeeRecords = employeeRecords?.filter((er: EmployeeRecord) => {
        if (er.active) {
            return false;
        }
        switch(er.employeeType) {
            case "US_FULL_TIME":
            case "US_PART_TIME":
            case "INT_FULL_TIME":
                return tab === TABS.EMPLOYEES;
            case "US_CONTRACTOR":
            case "INT_CONTRACTOR":
                return tab === TABS.CONTRACTORS;
            case "US_VENDOR":
                return tab === TABS.VENDORS;
            default:
                return false;
        }
    });

    const activeEmployeeRecords = employeeRecords?.filter((er: EmployeeRecord) => {
        if (!er.active) {
            return false;
        }
        switch(er.employeeType) {
            case "US_FULL_TIME":
            case "US_PART_TIME":
            case "INT_FULL_TIME":
                return tab === TABS.EMPLOYEES;
            case "US_CONTRACTOR":
            case "INT_CONTRACTOR":
                return tab === TABS.CONTRACTORS;
            case "US_VENDOR":
                return tab === TABS.VENDORS;
            default:
                return false;
        }
    });

    const employeeRecordsTableRow = (er: EmployeeRecord) => {
        return (
            <>
                <div 
                    className="app-employee-records-grid-row-item"
                    onClick={() => handleEditEmployeeRecord(er)}   
                >
                    {erGetCPValue(er, "system-firstName")} {erGetCPValue(er, "system-lastName")}
                </div>
                <div className="app-employee-records-grid-row-item">
                    {erGetCPValue(er, "system-title")}
                </div>
                <div className="app-employee-records-grid-row-item">
                    {er.workEmail}
                </div>
                <div className="app-employee-records-grid-row-item">
                    <div className="app-employee-records-grid-actions">
                        <button
                            className="button-cancel"
                        >
                            Edit
                        </button>
                        <button
                            className="button-cancel"
                        >
                            Delete
                        </button>
                        <button
                            className="button-cancel"
                            onClick={()=> navigate(`/app/employee/time-off/adjust/${er.id}`) }
                        >
                            Adjust
                        </button>
                    </div>
                    
                </div>
            </>
        )
    }

    console.log("[AppEmployeeRecords] employeeRecords: ", employeeRecords);

    return (
        <>
            {employeeId &&
                <AppEmployeeRecordNew id={employeeId === "new" ? undefined : employeeId}/>
            }
            {!employeeId && employeeRecords && 
                <div className="app-employee-records">
                    <div className="app-employee-records-tabs">
                        <div 
                            className={tab === TABS.EMPLOYEES ? 
                                "app-employee-records-tab-selected" : "app-employee-records-tab"
                            }
                            onClick={() => setTab(TABS.EMPLOYEES)}
                        >
                            Employees
                        </div>
                        <div 
                            className={tab === TABS.CONTRACTORS ? 
                                "app-employee-records-tab-selected" : "app-employee-records-tab"
                            }
                            onClick={() => setTab(TABS.CONTRACTORS)}
                        >
                            Contractors
                        </div>
                        <div 
                            className={tab === TABS.VENDORS ? 
                                "app-employee-records-tab-selected" : "app-employee-records-tab"
                            }
                            onClick={() => setTab(TABS.VENDORS)}
                        >
                            Vendors
                        </div>
                        <div className="app-employee-records-tab-actions">
                            <div
                                className="app-employee-records-tab-action"
                                onClick={() => {
                                    navigate("/app/employee-records/new");
                                }}
                            >
                                <UserPlus size={16}/> Add Employee
                            </div>
                            
                        </div>
                        
                    </div>

                    {activeEmployeeRecords && activeEmployeeRecords.length > 0 &&
                        <>
                            <div className="app-employee-records-section">
                                Active Employees<span>{activeEmployeeRecords?.length} Employees</span>
                            </div>

                            <div className="app-employee-records-grid">
                                <>
                                    <div className="app-employee-records-grid-header-item">Name</div>
                                    <div className="app-employee-records-grid-header-item">Title</div>
                                    <div className="app-employee-records-grid-header-item">Email</div>
                                    <div className="app-employee-records-grid-header-item">Actions</div>

                                    {activeEmployeeRecords.map((er: EmployeeRecord) => {
                                            return (
                                                employeeRecordsTableRow(er)
                                            )
                                        }
                                    )}
                                </>
                            </div>
                        </>
                    }

                    {inactiveEmployeeRecords && inactiveEmployeeRecords.length > 0 &&
                        <>
                            <div className="app-employee-records-section">
                                Inactive Employees <span>{inactiveEmployeeRecords?.length} Employees</span>
                            </div>

                            <div className="app-employee-records-grid">

                                <div className="app-employee-records-grid-header-item">Name</div>
                                <div className="app-employee-records-grid-header-item">Title</div>
                                <div className="app-employee-records-grid-header-item">Email</div>
                                <div className="app-employee-records-grid-header-item">Actions</div>

                                {inactiveEmployeeRecords.map((er: EmployeeRecord) => {
                                    return (
                                        employeeRecordsTableRow(er)
                                    )
                                })}
                            </div>
                        </>
                    }
                </div>
            }
        </>
    )
}